import { type PersonalSettingsSpacesTableGroupMeta } from "./types";

export const DEFAULT_GROUP_META: PersonalSettingsSpacesTableGroupMeta = { isOpen: false };
